export default __webpack_public_path__ + "static/media/100GB.af32e869.png";